import { forwardRef, type Ref, type SVGProps } from "react";
const IconInstagramSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M21 2H11a9 9 0 0 0-9 9v10a9 9 0 0 0 9 9h10a9 9 0 0 0 9-9V11a9 9 0 0 0-9-9m7 19a7 7 0 0 1-7 7H11a7 7 0 0 1-7-7V11a7 7 0 0 1 7-7h10a7 7 0 0 1 7 7Z"
    />
    <path
      fill="currentColor"
      d="M16 9a7 7 0 1 0 7 7 7 7 0 0 0-7-7m0 12a5 5 0 1 1 5-5 5 5 0 0 1-5 5m7.5-14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3"
    />
  </svg>
);
const ForwardRef = forwardRef(IconInstagramSVG);
ForwardRef.displayName = "IconInstagram";
export { ForwardRef as IconInstagram };
